import PropTypes from 'prop-types'

import View from '../../../components/bantrab/view'
import { getBaseViewInfo } from '../../../components/bantrab/view/functions'
import { getArticle } from '../../../api/bantrab'

import { NEWS_DETAIL_QUERY } from '../../../api/bantrab/queries'

import Detail from '../../../components/bantrab/blog/detail'

async function getServerSideProps (context) {
  const { id } = context.params

  const { head, navbar, footer } = await getBaseViewInfo()

  let page = await getArticle(id, NEWS_DETAIL_QUERY)
  page = await page.json()

  return {
    props: {
      head,
      navbar,
      body: page,
      footer
    }
  }
}

const Home = ({ head, navbar, body, footer }) => {
  return <View
    {...{ head, navbar, footer }}>
    <Detail
      article={body} />
  </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.object,
  footer: PropTypes.object
}

export { getServerSideProps }
export default Home
